import { resolveApiUrl } from "@/shared/lib/api-call";

/** Download an authenticated API response through the same browser seam used by every API call. */
export async function downloadFile(path: string, filename: string): Promise<void> {
  const response = await fetch(resolveApiUrl(path), {
    credentials: "include",
    cache: "no-store",
    headers: { accept: "text/csv" },
  });
  if (!response.ok) throw new Error(`Download failed (HTTP ${response.status})`);
  const objectUrl = URL.createObjectURL(await response.blob());
  try {
    const anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
